import { createStore, createEffect, createEvent, combine } from 'effector';
import { AccountsApi } from '@shared/api/rest';
import type { AccountRequest, AccountResponse } from '@shared/api/rest/accounts';
import { ApiUtils } from '@shared/utils';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const effect = createEffect((params: IQueryParams<AccountRequest>) => AccountsApi.getAccounts(params?.request, params?.signal));

const clearEvent = createEvent();

const $dataStore = createStore<AccountResponse[]>([])
  .on(effect.done, (current, { result }) => result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, pending) => pending)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, { error }) => error.message)
  .on(effect.done, () => null)
  .reset(clearEvent);

export const $accountStore = {
  events: {
    update: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
